import React, { useContext, useEffect, useRef, useState } from "react";
import "./SearchBar.css"
import Constants from "../locals/constants.json"
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext"

const SearchBar = (prop) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const afterTomorrow = new Date(today);
    afterTomorrow.setDate(today.getDate() + 2);
    const [datesModalOpened, setDatesModalOpened] = useState(false);
    const [numOfGuests, setNumOfGuests] = useState(0);
    const [startDate, setStartDate] = useState(tomorrow);
    const [endDate, setEndDate] = useState(afterTomorrow);
    const [modalStyle, setModalStyle] = useState(null);
    const searchBarRef = useRef(null);
    const modalRef = useRef(null);
    const classname = "search-bar " + prop["class"];

    const { t, language } = useContext(LanguageContext);

    const handleModal = (bo = true) => {
        setDatesModalOpened(bo);
        if (!bo && (!endDate || !startDate || handleNumOfNights() == 0)) {
            setStartDate(new Date(tomorrow));
            setEndDate(new Date(afterTomorrow));
        }
    }
    const handleGuests = (op) => {
        setNumOfGuests((numOfGuests + op + 1 > Constants.numOfGuests.length
            || numOfGuests + op < 0
        ) ? numOfGuests : numOfGuests + op);

    }
    const handleNumOfNights = () => {

        return (!endDate || !startDate) ? 0 : (endDate - startDate) / 86400000;
    }

    const navigate = useNavigate();

    const handleBookNow = () => {
        navigate(`/${language.value}/booking?check_in_date=${(new Date(startDate)).toISOString().split('T')[0]}&check_in_date=${(new Date(endDate)).toISOString().split('T')[0]}`);
    };

    return (
        <>
            <div className={classname} ref={searchBarRef}>
                <div className="search-bar-wrapper">
                    <div className="dates force-focus" >
                        <div className="search-bar-dates" onClick={() => handleModal(true)} >
                            <span class="material-symbols-outlined notranslate"> date_range </span>
                            <div className="search-bar-dates-input">
                                <div className="search-bar-label">{t("hero", "dates")}</div>
                                <input type="search-bar-checkin" readOnly
                                    value={(startDate?.toLocaleDateString('en-GB', { day: "numeric", month: "short" }) || "      ") + " - " + (endDate?.toLocaleDateString('en-GB', { day: "numeric", month: "short" }) || "      ")} >
                                </input>
                            </div>
                        </div>
                        {datesModalOpened &&
                            <div className="search-bar-modal"
                                ref={modalRef} style={modalStyle} >
                                <div className="search-bar-modal-title">
                                    {handleNumOfNights() == 0 ? (
                                        <div className="search-bar-modal-title-desc">
                                            <span class="material-symbols-outlined notranslate">calendar_add_on</span>
                                            <p>{t("hero", "selectDates")}</p>
                                        </div>
                                    ) : (
                                        <div className="search-bar-modal-title-desc">
                                            <span class="material-symbols-outlined notranslate">moon_stars</span>
                                            <p> {handleNumOfNights()} {t("hero", "nightsSelected")}</p>
                                        </div>
                                    )
                                    }
                                    <span class="material-symbols-outlined notranslate"
                                        onClick={() => handleModal(false)}>close</span>
                                </div>
                                <DatePicker
                                    selected={startDate}
                                    onChange={(dates) => {
                                        const [start, end] = dates;
                                        setStartDate(start);
                                        setEndDate(end);
                                    }}
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectsRange
                                    inline
                                    monthsShown={2}
                                    minDate={new Date()}
                                    calendarStartDay={1}
                                    shouldCloseOnSelect={false}
                                />

                            </div>
                        }
                    </div>
                    <div className="search-bar-guest" onClick={() => handleModal(false)}>
                        <span class="material-symbols-outlined notranslate">people</span>
                        <div className="search-bar-guest-input">
                            <div className="search-bar-label">{t("hero", "guests")}</div>
                            {Constants.numOfGuests[numOfGuests].label}
                        </div>

                        <div className="search-bar-guest-controls">
                            <button className="search-bar-guest-icon-right">
                                <span class="material-symbols-outlined notranslate"
                                    onClick={() => handleGuests(-1)} > remove</span>
                            </button>
                            <button className="search-bar-guest-icon-right">
                                <span class="material-symbols-outlined notranslate"
                                    onClick={() => handleGuests(1)} >add</span>
                            </button>
                        </div>
                    </div>
                    <button className="search-bar-button search-bar-button-desktop" onClick={handleBookNow}>{t("hero", "checkAvailability")}</button>
                    <button className="search-bar-button search-bar-button-mobile" onClick={handleBookNow}>{t("hero", "bookNow")}</button>

                </div>

            </div>



        </>
    )
}

export default SearchBar;